import {
    DAYS,
    DAYS_LABEL,
    HOURS,
    HOURS_LABEL,
    MONTHS,
    MONTHS_LABEL,
    OFFSET_START_DATE_LIMIT,
    WEEKS,
    WEEKS_LABEL,
    WINT_EMAIL_SUFFIX
} from "../../../Constants/constants";
import moment from "moment";

export const getResolutionName = (resolution) => {
    switch (resolution) {
        case HOURS:
            return HOURS_LABEL;
        case DAYS:
            return DAYS_LABEL;
        case WEEKS:
            return WEEKS_LABEL;
        default:
            return MONTHS_LABEL;
    }
}

export const getMonthlyStartDate = () => {
    const date = new Date();
    date.setMonth(date.getMonth());
    return new Date(date.getFullYear(), date.getMonth() - 11, 2);
}

export const getMonthlyOffsetStartDate = (offset) => {
    const date = new Date();
    date.setMonth(date.getMonth());
    date.setFullYear(date.getFullYear() + offset);
    return new Date(date.getFullYear(), date.getMonth() - 11, 2);
}

export const getMonthlyEndDate = (referenceToDate) => {
    let date
    if (referenceToDate) {
        date = new Date(referenceToDate);
    } else {
        date = new Date();
    }
    date.setFullYear(date.getFullYear());
    return date;
}

export const getMonthlyOffsetEndDate = (offset) => {
    const date = new Date();
    date.setMonth(date.getMonth());
    date.setFullYear(date.getFullYear() + offset);
    return date;
}

export const getDailyStartDate = () => {
    const date = new Date();
    date.setMonth(date.getMonth());
    return new Date(date.setDate(date.getDate() - 7));
}

export const getDailyEndDate = () => {
    const date = new Date();
    date.setMonth(date.getMonth());
    return new Date(date.getFullYear(), date.getMonth(), 0);
}

export const getDailyOffsetStartDate = (offset, referenceToDate) => {
    let date
    if (!referenceToDate) {
        date = new Date();
    } else {
        date = new Date(referenceToDate);
    }

    if (offset === 0) {
        return new Date(date.setDate(date.getDate() - 6));
    }
    return new Date(date.setDate(date.getDate() - 6 + (7 * offset)));
}

export const getDailyOffsetEndDate = (offset, referenceToDate) => {
    const startDate = getDailyOffsetStartDate(offset, referenceToDate);
    return new Date(startDate.setDate(startDate.getDate() + 6));
}

export const getWeeklyStartDate = (referenceToDate) => {
    let date
    if (referenceToDate) {
        date = getMonthlyEndDate(referenceToDate);
    } else {
        date = getMonthlyEndDate();
    }

    date.setDate(date.getDate() - 11 * 7);
    return new Date(date);
}

export const getWeeklyOffsetStartDate = (offset, referenceToDate) => {
    let date
    if (referenceToDate) {
        console.log('referenceToDate',referenceToDate)
        date = new Date(referenceToDate);
        if(offset === 0){
            return date
        }
        date.setDate(date.getDate() + (11 * 7 * offset));
        console.log('date after referenceToDate',date)
        return new Date(date);
    } else {
        date = getWeeklyStartDate();
    }

    if (offset === 0) {
        return new Date(date);
    }

    date.setDate(date.getDate() + (11 * 7 * offset));
    return new Date(date);
}

export const getWeeklyOffsetEndDate = (offset, referenceToDate) => {
    let date
    if (referenceToDate) {
        date = getWeeklyOffsetStartDate(offset, referenceToDate);
        date.setDate(date.getDate() + 11 * 7);
        if(offset === 0){
            return date
        }
        return getWeeklyOffsetStartDate(offset +1);
    } else {
        date = getWeeklyOffsetStartDate(offset);
    }

    date.setDate(date.getDate() + 11 * 7);
    if (offset === 0) {
        return new Date(date);
    }

    const endDate = getWeeklyOffsetStartDate(offset +1);
    return new Date(endDate);
}

export const getEndDate = (startDate, resolution) => {
    const date = new Date(startDate);
    switch (resolution) {
        case HOURS:
            return date;
        case DAYS:
            date.setDate(date.getDate() + 6);
            return date;
        case WEEKS:
            date.setMonth(date.getMonth() + 1);
            date.setDate(date.getDate() - 1);
            return date;
        default:
            break;
    }
}

export const getLastMonthStartDate = () => {
    const date = new Date();
    date.setDate(0)
    date.setDate(1)
    return date

}

export const getLastMonthEndDate = () => {
    const date = new Date();
    date.setDate(0)
    return date
}

export const setCsvHeaders = (resolution) => {
    switch (resolution) {
        case WEEKS:
            return ['', 'From', 'To'];
        default:
            return ['', 'Date'];
    }
}

export const buildCategoriesData = (responseData, resolution) => {
    let categoryData = [];
    responseData.forEach((entity, index) => {
        categoryData = getCategoriesByResolution(resolution, entity.date, categoryData)
    });
    return categoryData
}

export const getPointResolution = (e, resolution, setSelectedDate, setBarIndex, setModalShow) => {
    let date;
    switch (resolution) {
        case DAYS: {
            date = moment(e.point.category).format('DD-MM-YYYY');
        }
        case MONTHS: {
            date = moment(e.point.category).format('MM-YYYY');
            date = "01-" + date;
        }
        case WEEKS: {
            let dates = e.point.category.split('-')
            date = moment(dates[0].trim()).format('DD-MM-YYYY');
        }
    }
    date = date.replaceAll('-', '/').split("/");
    date = new Date(+date[2], date[1] - 1, +date[0]);
    if (resolution === WEEKS) {
        date = new Date(date.setDate(date.getDate()));
    }
    setSelectedDate(date);
    setBarIndex(e?.point?.index || 0);
    setModalShow(true);

}

export const buildOverTimeCategoriesData = (responseData, resolution) => {
    if (responseData.length === 0) {
        return
    }
    let categoryData = [];
    responseData[0].data.forEach((entityData, index) => {
        categoryData = getCategoriesByResolution(resolution, entityData.date, categoryData)
    });
    return categoryData
}


export const getCategoriesByResolution = (resolution, dateLabel, categoryData) => {
    switch (resolution) {
        case MONTHS: {
            const date = moment(dateLabel).format('MMM, YYYY')
            categoryData.push(date);
            break;
        }
        case WEEKS: {
            dateLabel = dateLabel.substring(0, 10)
            let dateInOneWeek = new Date(dateLabel);
            dateInOneWeek.setDate(dateInOneWeek.getDate() + 6)
            const fromDate = moment(dateLabel).format('ll')
            const toDate = moment(dateInOneWeek).format('ll')
            categoryData.push(fromDate + ' - ' + toDate);
            break;
        }
        case DAYS: {
            const daysDate = moment(dateLabel).format('ll')
            categoryData.push(daysDate);
            break;
        }
        case HOURS: {
            const hour = moment(dateLabel).format('HH').concat(':00')

            categoryData.push(hour);
        }

    }
    return categoryData

}

export const pushCsvDates = (resolution, dateLabel, row) => {
    switch (resolution) {
        case MONTHS:
            const date = moment(dateLabel).format('MMMM, YYYY')
            row.push(date);
            break;
        case WEEKS:
            dateLabel = dateLabel.substring(0, 10)
            let dateInOneWeek = new Date(dateLabel);
            dateInOneWeek.setDate(dateInOneWeek.getDate() + 6)
            const fromDate = moment(dateLabel).format('ll')
            const toDate = moment(dateInOneWeek).format('ll')
            row.push(fromDate, toDate);
            break;
        case DAYS:
            const daysDate = moment(dateLabel).format('ll')
            row.push(daysDate);
            break;
        case HOURS:
            const hour = moment(dateLabel).format('HH').concat(':00')
            row.push(hour);
            break;
    }
    return row;
}

export const getChartLabels = (resolution, dateLabel) => {
    switch (resolution) {
        case MONTHS:
            const year = dateLabel.substring(3, 7);
            const month = dateLabel.substring(0, 2);
            const day = 1;
            const date = moment(new Date(year, month, day)).subtract(1, 'month').format('MMM.YYYY');
            return date;
        case WEEKS:
            const fromYear = dateLabel.split(' ')[0].split('-');
            const toYear = dateLabel.split(' ')[2].split('-');
            const fromDate = moment(new Date(fromYear[2], fromYear[1] - 1, fromYear[0])).format('ll');
            const toDate = moment(new Date(toYear[2], toYear[1] - 1, toYear[0])).format('ll');
            return `${fromDate} - ${toDate}`;
        case DAYS:
            const daysArray = dateLabel.split('-');
            const daysDate = moment(new Date(daysArray[2], daysArray[1] - 1, daysArray[0])).format('ll');
            return daysDate;
    }
}

export const sortResponseData = (response) => {
    return response.slice().sort(function compare(a, b) {
        let dateA = new Date(a.from);
        let dateB = new Date(b.from);
        return dateA - dateB;
    });
}

export const getMonthLabel = (lastMonthLabel) => {
    return moment(lastMonthLabel).format('MMM. YY')
}

export const isWintUser = (email) => {
    return email.substring(email.length - 8) === WINT_EMAIL_SUFFIX;
}

export const getNextDay = (dayName, dateReference) => {
    let date;
    dateReference ? date = new Date(dateReference) : date = new Date();
    let now = date.getDay();
    let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    let day = days.indexOf(dayName.toLowerCase());
    let diff = day - now;
    diff = diff < 1 ? 7 + diff : diff;
    let nextDayTimestamp = date.getTime() + (1000 * 60 * 60 * 24 * diff);
    return new Date(nextDayTimestamp);

};

export const getNextDayWeek = (dateReference) => {
    let date;
    date = new Date(dateReference)
    let nextDayTimestamp = date.getTime() + (1000 * 60 * 60 * 24 * 77);
    return getNextDay('sunday', new Date(nextDayTimestamp))

}

export const setDateReferenceByResolution = (resolution, setReferenceToDateDaily, setReferenceToDateWeekly, responseData, response, offset, setRightArrowDisabled, setLeftArrowDisabled, startDate, weekStartDate) => {
    if (resolution === WEEKS) {
        setReferenceToDateDaily(createReferenceToDate(response, 0));
        setDisabledOffsetButtons(responseData, offset, setRightArrowDisabled, setLeftArrowDisabled, weekStartDate, resolution);
    }
    if (resolution === DAYS) {
        setReferenceToDateWeekly(createReferenceToDate(response, 1000 * 60 * 60 * 24 * -2));
        setDisabledOffsetButtons(responseData, offset, setRightArrowDisabled, setLeftArrowDisabled, startDate, resolution);
    } else {
        setDisabledOffsetButtons(responseData, offset, setRightArrowDisabled, setLeftArrowDisabled, startDate, resolution);
    }
}

export const setOverTimeDateReferenceByResolution = (resolution, setReferenceToDateDaily, setReferenceToDateWeekly, response, offset, setRightArrowDisabled, setLeftArrowDisabled, startDate, weekStartDate) => {

    if (resolution === WEEKS) {
        setReferenceToDateDaily(createReferenceToDate(response.entities[0], 0));
        setDisabledOffsetButtons(response?.entities[0]?.data, offset, setRightArrowDisabled, setLeftArrowDisabled, weekStartDate, resolution);
    }
    if (resolution === DAYS) {
        setReferenceToDateWeekly(createReferenceToDate(response.entities[0], 1000 * 60 * 60 * 24 * -2));
        setDisabledOffsetButtons(response?.entities[0]?.data, offset, setRightArrowDisabled, setLeftArrowDisabled, startDate, resolution);
    } else {
        setDisabledOffsetButtons(response, offset, setRightArrowDisabled, setLeftArrowDisabled, startDate, resolution);
    }
}


export const setDisabledOffsetButtons = (data, offset, setRightArrowDisabled, setLeftArrowDisabled, startDate) => {
            const startDateRes = data[0]?.from ? new Date(data[0].from) : startDate;
            startDateRes < OFFSET_START_DATE_LIMIT ? setLeftArrowDisabled(true) : setLeftArrowDisabled(false);
            offset < 0 ? setRightArrowDisabled(false) : setRightArrowDisabled(true);
}

export const checkEndDate = (endDate) => {
    let maxEndDate = getNextDay('sunday',)
    if (endDate.getTime() > maxEndDate.getTime()) {
        return maxEndDate
    }
    return endDate

}

export const checkStartDate = (startDate, endDate) => {
    let minStartDateTimeStamp = endDate.getTime() + (1000 * 60 * 60 * 24 * -77);
    let minStartDate = new Date(minStartDateTimeStamp)
    let minStartDateNextSunday = moment(getNextDay('sunday', minStartDate)).format('YYYY-MM-DD');
    let currentDayNextSunday = moment(getNextDay('sunday')).format('YYYY-MM-DD')
    if (minStartDateNextSunday === currentDayNextSunday) {
        return startDate
    }

    if (startDate < minStartDate) {
        return minStartDate
    }
    return startDate

}

export const createReferenceToDate = (response, timeToAdd) => {
    if (response && response.data.length > 0) {
        let dateStr = new Date(response.data[response.data.length - 1].to).getTime() + timeToAdd
        let formattedDateStr = moment(dateStr).format('YYYY-MM-DD')
        return formattedDateStr
    }
}


export const gqlDateFormat = (date) => {
    return date.toLocaleDateString('pt-br').split('/').reverse().join('-');
}

export const getResponseTypeList = (types) => {
    let typesArr = [];
    if (types.includes('OTHER')) {
        typesArr.push('OTHER')
    }
    if (types.includes('COOLING_TOWER')) {
        typesArr.push('COOLING_TOWER')
    }
    if (types.includes('MAIN_INLET')) {
        typesArr.push('MAIN_INLET')
    }
    return typesArr;
}

export const filterPreviousSelectedEntities = (typeArr, currentValuesArr, previousSelectedValues) => {
    let entitiesToFilter = previousSelectedValues;
    let filteredEntities = entitiesToFilter.filter(e => typeArr.includes(e.type[0]))
    let idsToDelete = []
    currentValuesArr.forEach((value) => {
        filteredEntities.forEach((nestedValue) => {
            if (value.id === nestedValue.id) {
                idsToDelete.push(value.id)
            }
        })
    })
    for (let i = 0; i < filteredEntities.length; i++) {
        let obj = filteredEntities[i];
        if (idsToDelete.indexOf(obj.id) !== -1) {
            filteredEntities.splice(i, 1);
            i--;
        }
    }

    return filteredEntities

}